var React = require('react');

function ArrowRoundedRight8x13 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.3,11.4l5-4.9l-5-4.9c-0.4-0.4-0.4-0.9,0-1.3l0,0c0.4-0.4,0.9-0.4,1.3,0L8,6.5l-6.4,6.2c-0.4,0.4-0.9,0.3-1.3,0l0,0\r\n\tC-0.1,12.4-0.1,11.8,0.3,11.4z"}));
}

ArrowRoundedRight8x13.defaultProps = {"width":"8px","height":"13px"};

module.exports = ArrowRoundedRight8x13;

ArrowRoundedRight8x13.default = ArrowRoundedRight8x13;
